module.exports = __webpack_public_path__ + "static/media/profile-3.1dc07622.svg";